var CommunicationService = /** @class */ (function () {
    function CommunicationService() {
    }
    CommunicationService.singleton = function () {
        if (!CommunicationService.communicationService) {
            CommunicationService.communicationService = new CommunicationService();
        }
        return CommunicationService.communicationService;
    };
    CommunicationService.prototype.emitCustomEvent = function (eventName, data) {
        var emit = new CustomEvent(eventName, { detail: data });
        window.dispatchEvent(emit);
    };
    CommunicationService.prototype.receiveCustomEvent = function (eventName, callback) {
        window.addEventListener(eventName, callback);
    };
    CommunicationService.prototype.removeEventListener = function (eventName, listener) {
        window.removeEventListener(eventName, listener);
    };
    return CommunicationService;
}());
export { CommunicationService };
